import React, { useState } from "react";

interface WelcomePopupProps {
  onClose: () => void;
}

const WelcomePopup: React.FC<WelcomePopupProps> = ({ onClose }) => {
  return (
    <>
      <div
        onClick={onClose}
        style={{
          position: "fixed",
          inset: 0,
          backgroundColor: "rgba(0, 0, 0, 0.55)",
          zIndex: 1050,
        }}
      />

      <div
        style={{
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          zIndex: 1055,
          width: "100%",
          maxWidth: "480px",
          background: "#ffffff",
          borderRadius: "16px",
          boxShadow: "0 24px 60px rgba(0,0,0,0.2)",
          overflow: "hidden",
          transition: "max-width 0.3s ease",
        }}
      >
        {/* ── HEADER ── */}
        <div
          style={{
            background: "#e6510d",
            padding: "28px 32px 24px",
            position: "relative",
          }}
        >
          {/* Close Button */}
          <button
            onClick={onClose}
            style={{
              position: "absolute",
              top: "14px",
              right: "16px",
              background: "rgba(255,255,255,0.15)",
              border: "none",
              color: "#fff",
              borderRadius: "50%",
              width: "32px",
              height: "32px",
              fontSize: "18px",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              lineHeight: 1,
            }}
            title="Close"
          >
            &times;
          </button>

          <div style={{ textAlign: "center" }}>
            {/* Wave emoji banner */}
            <div
              style={{
                width: "72px",
                height: "72px",
                margin: "0 auto 16px",
                borderRadius: "50%",
                background: "rgba(255,255,255,0.15)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <i
                className="ti ti-shield-check"
                style={{ fontSize: "36px", color: "#fff" }}
              ></i>
            </div>

            <h2
              style={{
                color: "#fff",
                fontWeight: 700,
                fontSize: "24px",
                margin: "0 0 8px",
              }}
            >
              Welcome to the Aupertz Portal
            </h2>

            <p
              style={{
                color: "rgba(255,255,255,0.85)",
                fontSize: "15px",
                margin: 0,
              }}
            >
              Your trusted platform for secure background verification.
            </p>
          </div>
        </div>

        {/* ── BODY ── */}
        <div style={{ padding: "28px 32px" }}>
          <p
            style={{
              color: "#4b5563",
              fontSize: "15px",
              lineHeight: "26px",
              textAlign: "center",
              marginBottom: "24px",
            }}
          >
            Complete your background verification quickly and securely. Upload
            the required documents, monitor your verification progress, and stay
            informed throughout every stage of the verification process.
          </p>

          <ul
            style={{
              color: "#4b5563",
              fontSize: "14px",
              lineHeight: "30px",
              paddingLeft: 0,
              listStyle: "none",
              marginBottom: "30px",
            }}
          >
            <li>
              <i className="ti ti-check text-success me-2"></i>
              Complete your background verification securely
            </li>

            <li>
              <i className="ti ti-file-upload text-primary me-2"></i>
              Upload required verification documents
            </li>

            <li>
              <i className="ti ti-progress-check text-warning me-2"></i>
              Track your verification status
            </li>

            <li>
              <i className="ti ti-lock text-danger me-2"></i>
              Your information is protected with secure data handling
            </li>
          </ul>

          {/* Action Buttons */}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "12px",
            }}
          >
            <button
              onClick={onClose}
              style={{
                background: "#e6510d",
                color: "#fff",
                border: "none",
                borderRadius: "10px",
                padding: "13px",
                fontSize: "15px",
                fontWeight: 600,
                cursor: "pointer",
                transition: "0.3s",
              }}
            >
              Continue to Dashboard
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default WelcomePopup;
